import classNames from "classnames";
import Link from "next/link";
import { NewsCardProps } from "../../../../../types/NewsCardProps";
import styles from "./NewsCard.module.scss";

const NewsCard = (props: NewsCardProps) => {
  const { date, desc, image, readLink, title } = props;
  const DateFilter = new Date(date);
  return (
    <Link data-testid="newsCard" href={`/news/article/${readLink}`}>
      <div className={classNames(styles.newsCard)}>
        <figure>
          <img src={image} alt="" />
        </figure>
        <h4>{title}</h4>
        <span>
          {DateFilter.toLocaleString("en-us", { month: "long" })} {DateFilter.getDate()}, {DateFilter.getFullYear()}
        </span>
        <div dangerouslySetInnerHTML={{ __html: desc }} className={classNames(styles.desc)} />
        <Link href={`/news/article/${readLink}` ?? "/"}>
          <a>READ ALL</a>
        </Link>
      </div>
    </Link>
  );
};

export default NewsCard;
